import { useCallback, useEffect, useRef } from 'react';
import { RefObjectForHighchartsReact } from '../../../CommonComponents/OPL/charts/Chart.types';

export const useChartReflow = () => {
  const whatIfSidebarEl = document.querySelector('.WhatIfs');

  const chartRef = useRef<RefObjectForHighchartsReact>(null);

  const reflowChart = useCallback(() => {
    if (chartRef.current !== null) {
      chartRef.current.chart.reflow();
    }
  }, []);

  useEffect(() => {
    if (whatIfSidebarEl) {
      whatIfSidebarEl.addEventListener('transitionend', reflowChart);
    }

    return () => {
      if (whatIfSidebarEl) {
        whatIfSidebarEl.removeEventListener('transitionend', reflowChart);
      }
    };
  }, [whatIfSidebarEl, reflowChart]);

  return { chartRef };
};
